export const GreekTranslate = {
    "General": "Γενικά",
    "Binary Tree": "Δυαδικό Δέντρο",
    "AVL Tree": "Δέντρο AVL",
    "Heap": "Σωρός",
    "Directed": "Κατευθυνόμενος",
    "Undirected": "Μη κατευθυνόμενος",
    "Singly Linked List": "Απλά συνδεδεμένη λίστα",
    "Doubly Linked List": "Διπλά συνδεδεμένη λίστα",
    "1D Array": "Μονοδιάστατος Πίνακας",
    "2D Array": "Δισδιάστατος Πίνακας",
    "Dynamic Array": "Δυναμικός Πίνακας",
    "Circular Queue": "Κυκλική Ουρά",
    "Priority Queue": "Ουρά Προτεραιότητας",
    "Array-based Stack": "Στοίβα με Πίνακα",
    "Linked List Stack": "Στοίβα με Συνδεδεμένη Λίστα",
    "Chaining": "Συσχέτιση (Chaining)",
    "Hash Set": "Σύνολο Κατακερματισμού",
    "Tree Set": "Δενδροειδές Σύνολο",
    "Open Addressing": "Ανοιχτή Διευθυνσιοδότηση",
    "Graph": "Γράφου",
    "Tree": 'Δέντρου',
    "List": "Λίστας",
    "Array": "Πίνακα",
    "Queue": "Ουράς",
    "Stack": "Στοίβας",
    "HashTable": "Πίνακα Κατακερματισμού",
    "Set": "Σύνολου",
    "Basics": "Βασικές Αρχές",
    "Advanced": "Προχωρημένα",
    "Python": "Python"
};

const structNames = {
    "Graph": "Γράφος",
    "Tree": 'Δέντρο',
    "List": "Λίστα",
    "Array": "Πίνακας",
    "Queue": "Ουρά",
    "Stack": "Στοίβα",
    "HashTable": "Πίνακας Κατακερματισμού",
    "Set": "Σύνολο"
}

export const subNames = {
    "Binary Tree": "Δυαδικού Δέντρου",
    "AVL Tree": "Δέντρου AVL",
    "Heap": "Σωρού",
    "Directed": "Κατευθυνόμενου",
    "Undirected": "Μη κατευθυνόμενου",
    "Singly Linked List": "Απλά συνδεδεμένης λίστας",
    "Doubly Linked List": "Διπλά συνδεδεμένης λίστας",
    "1D Array": "Μονοδιάστατου Πίνακα",
    "2D Array": "Δισδιάστατου Πίνακα",
    "Dynamic Array": "Δυναμικού Πίνακα",
    "Circular Queue": "Κυκλικής Ουράς",
    "Priority Queue": "Ουράς Προτεραιότητας",
    "Array-based Stack": "Στοίβας με Πίνακα",
    "Linked List Stack": "Στοίβας με Συνδεδεμένη Λίστα",
    "Chaining": "Συσχέτισης (Chaining)",
    "Hash Set": "Συνόλου Κατακερματισμού",
    "Tree Set": "Δενδροειδού Σύνολο",
    "Open Addressing": "Ανοιχτής Διευθυνσιοδότησης",
    "Basics": "Βασικών Αρχών",
    "Advanced": "Προχωρημένων",
};

export const stagesNames = {
    "introduction": "Εισαγωγή",
    "searching": "Αναζήτηση",
    "other categories": "Άλλες Κατηγορίες",
    "insertion-deletion": "Εισαγωγή - Διαγραφή",
    "mst": "MST",
    "insertion-deletion-searching": "Εισαγωγή - Διαγραφή - Αναζήτηση",
    "insertion / deletion": "Εισαγωγή / Διαγραφή",
    "binary search tree": "Δυαδικό Δέντρο Αναζήτησης",
    "deletion": "Διαγραφή",
    "insertion": "Εισαγωγή",
    "functions": "Συναρτήσεις",
    "sorting": "Ταξινόμηση",
    "variety of arrays": "Διάφοροι Τύποι Πινάκων",
    "enque/dequeue": "Εισαγωγή / Εξαγωγή",
    "insertion/deletions": "Εισαγωγή / Διαγραφές",
    "insertion - deletion -  searching": "Εισαγωγή - Διαγραφή - Αναζήτηση",
    "conditions and loops": "Συνθήκες και Βρόχοι",
    "variables and commands": "Μεταβλητές και Εντολές",
    "strings": "Συμβολοσειρές",
    "lists": "Λίστες",
    "gui with tkinter": "GUI με Tkinter",
    "object-oriented programming": "Αντικειμενοστραφής Προγραμματισμός",
    "functions, files and dictionaries": "Συναρτήσεις, Αρχεία και Λεξικά"
};


export const sideBarLinks = {
    "Description": "Περιγραφή",
    "Flashcards": "Κάρτες Μνήμης",
    "Quiz": "Κουίζ",
    "Games": "Παιχνίδια",
    "Create": "Δημιουργία",
    "Graph": "Γράφος",
    "Tree": 'Δέντρο',
    "List": "Λίστα",
    "Array": "Πίνακας",
    "Queue": "Ουρά",
    "Stack": "Στοίβα",
    "HashTable": "Πίνακας Κατακερματισμού",
    "Set": "Σύνολο",
    "Python": "Python"
};
